var map = {
	"./circle_Areca_pressed.png": 9399,
	"./circle_Barringtoniaasiatica_pressed.png": 7402,
	"./circle_Chinaberry_pressed.png": 1008,
	"./circle_Erythrina_pressed.png": 9951,
	"./circle_Ficus_pressed.png": 7595,
	"./circle_Imperata_pressed.png": 1890,
	"./circle_LargeLeavedNanmu_pressed.png": 4408,
	"./circle_Mango_pressed.png": 4315,
	"./circle_PaperMulberry_pressed.png": 1669,
	"./circle_Parasolleaftree_pressed.png": 3353,
	"./circle_Soapberry_pressed.png": 8606,
	"./circle_SpinyBamboo_pressed.png": 9412,
	"./circle_TaiwanFlamegold_pressed.png": 1098,
	"./circle_Taiwancrapemyrtle_pressed.png": 4677,
	"./circle_VitexNigra_pressed.png": 9168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5628;